import { useEffect, useState } from "react";

const query = (breakpoint) => `(max-width: ${breakpoint - 0.02}px)`;

/** True while the window is narrower than `breakpoint` px (default 768: phones and small tablets); follows resizes. */
export default function useIsNarrow(breakpoint = 768) {
  const read = () => {
    if (typeof window === "undefined") return false;
    if (typeof window.matchMedia === "function") return window.matchMedia(query(breakpoint)).matches;
    return window.innerWidth < breakpoint;
  };
  const [narrow, setNarrow] = useState(read);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const update = () => setNarrow(read());
    if (typeof window.matchMedia !== "function") {
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    }
    const list = window.matchMedia(query(breakpoint));
    update();
    if (list.addEventListener) {
      list.addEventListener("change", update);
      return () => list.removeEventListener("change", update);
    }
    list.addListener(update); // Safari < 14
    return () => list.removeListener(update);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return narrow;
}
